import { fromJS } from 'immutable'
import {
  MY_TIMESHEET_GET_REQUEST,
  MY_TIMESHEET_GET_SUCCESS,
  MY_TIMESHEET_GET_FAILURE,
  MY_TIMESHEET_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case MY_TIMESHEET_GET_REQUEST:
      return state
        .set('isFetching', true)
    case MY_TIMESHEET_GET_SUCCESS:
      return state
        .set('myTimesheet', fromJS(action.payload))
        .set('isFetching', false)
    case MY_TIMESHEET_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case MY_TIMESHEET_GET_RESET:
      return state
        .delete('myTimesheet')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/my-timesheet-get-reducer.js